import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          Copyright 2025 &copy; PindScript - All Right Reserved.
        </div>
        <div className="footer-right">
          Made by <a href="https://linkedin.com/in/vaibhavagg2005/" target="_blank" rel="noreferrer">Vaibhav</a> and <a href="https://www.linkedin.com/in/aastha-nagpal/" target="_blank" rel="noreferrer">Aastha</a>
        </div>
      </div>
    </footer>
  );
}